import React from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  Avatar,
  Grid,
  IconButton,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const PlayersTableBody = ({ players, onMenuOpen }) => {
  return (
    <TableBody
      sx={{
        "& td, & th": {
          color: "#6A707E",
          fontWeight: 500,
          fontSize: "16px",
        },
      }}
    >
      {players.map((player) => (
        <TableRow
          key={player.id}
          sx={{
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)",
            "&:last-child td, &:last-child th": { borderBottom: 0 },
          }}
        >
          <TableCell>
            <Avatar
              alt={player.name}
              src={player.headshot}
              sx={{ borderRadius: 0 }}
            />
          </TableCell>
          <TableCell>{player.name}</TableCell>
          <TableCell>{player.nickname}</TableCell>
          <TableCell>{player.sport}</TableCell>
          <TableCell>{player.league}</TableCell>
          <TableCell>{player.team}</TableCell>
          <TableCell>#{player.number ?? "-"}</TableCell>
          <TableCell>{player.position}</TableCell>
          <TableCell>
            <Grid container alignItems="center">
              <Avatar
                src={player.nationalityFlag}
                sx={{ width: 24, height: 24, marginRight: 1 }}
              />
              {player.nationality}
            </Grid>
          </TableCell>
          <TableCell align="right">
            <IconButton onClick={(e) => onMenuOpen(e, player.id)}>
              <MoreVertIcon />
            </IconButton>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};

export default PlayersTableBody;
